import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { InfoCircle as n } from "iconoir-react";
import * as o from "react";
import { cn as m } from "../../utils.js";
import { Typography as s } from "../Typography/index.js";
const c = (r) => {
  if (!r) return "";
  if (Array.isArray(r))
    return r.join("; ");
  if (typeof r == "object" && !Array.isArray(r) && r !== null)
    return Object.values(r).join("; ");
  if (typeof r == "string")
    return r;
  throw new Error("Invalid errors type");
}, f = o.forwardRef(
  ({ className: r, title: t }, i) => t ? (t = c(t), /* @__PURE__ */ e("div", { ref: i, className: m(r, "flex items-center mt-0.75"), children: [
    /* @__PURE__ */ a(n, { className: "me-0.5 size-2.25 shrink-0 text-critical-500" }),
    /* @__PURE__ */ a(s, { variant: "smallBody", className: "text-critical", children: t })
  ] })) : null
);
f.displayName = "ErrorMessage";
export {
  f as ErrorMessage
};
